/* eslint-disable eqeqeq */
import React, { useState, Fragment } from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/styles";
import {
  Card,
  Checkbox,
  FormControlLabel,
  Grid,
  TextField,
  Toolbar,
  Typography,
  Paper,
  TableContainer,
  Table,
  TableBody,
  TableCell,
  TableRow,
  MenuItem,
} from "@material-ui/core";
import { HttpRequest } from "../../../utils/httpRequests";
import NavBar from "../../../components/NavBar/NavBar";
import Button from "@material-ui/core/Button";
import CustomizedSnackbar from "../../../components/CustomizedSnackbar/CustomizedSnackbar";
import Select from "react-select";
import { IsEmpty } from "../../../utils/helper";
import ImageViewDialogV2 from "./ImageViewDialog";
import LoginMenu from "../../../components/LoginMenu/LoginMenu";

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
    fontWeight: 500,
    border: "1px solid " + theme.palette.common.white,
  },
  body: {
    fontSize: 14,
    //border: '1px solid '+theme.palette.primary.main,
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover,
    },
  },
}))(TableRow);

const useStyles = (theme) => ({
  icon: {
    marginRight: theme.spacing(1),
  },
  heroContent: {
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(2, 0, 2),
  },
  heroButtons: {
    marginTop: theme.spacing(4),
  },
  cardGrid: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
  card: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
  },
  cardMedia: {
    paddingTop: "56.25%", // 16:9
  },
  cardContent: {
    flexGrow: 1,
  },
  cardContentDiv: {
    display: "flex",
    justifyContent: "space-between",
  },
  footer: {
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(6),
  },
  tabsContainer: {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    marginTop: 70,
    marginBottom: 10,
    overFlow: "hidden",
  },
  contentContainer: {
    alignItems: "center",
    textAlign: "center",
    width: "100%",
    marginLeft: 10,
    marginRight: 5,
  },
  contentContainerSM: {
    alignItems: "center",
    textAlign: "center",
    width: "65%",
    marginLeft: 10,
    marginRight: 5,
  },
});

function DisputedDetail(props) {
  // eslint-disable-next-line react/prop-types
  const { data, featureId, isChecked, i } = props;

  const [isDisabled, setIsEnabled] = useState(false);

  const handleCheckBoxChange = (target) => {
    setIsEnabled(target.checked);
  };

  return (
    <>
      <StyledTableRow key={"row" + data.id + i}>
        <StyledTableCell
          component="th"
          scope="row"
          align="left"
          style={{ width: "30%", borderColor: "#fff1" }}
        >
          <b>Job #{featureId}</b>
        </StyledTableCell>

        <StyledTableCell
          component="th"
          scope="row"
          align="left"
          style={{ width: "10%", borderColor: "#fff1" }}
        >
          <b>Size</b>
        </StyledTableCell>
        <StyledTableCell
          component="th"
          scope="row"
          align="left"
          style={{ width: "10%", borderColor: "#fff1" }}
        >
          <b>Packaging</b>
        </StyledTableCell>
        <StyledTableCell
          component="th"
          scope="row"
          align="left"
          style={{ width: "10%", borderColor: "#fff1" }}
        >
          <b>Product Thumbnail</b>
        </StyledTableCell>
        <StyledTableCell
          component="th"
          scope="row"
          align="left"
          style={{ width: "10%", borderColor: "#fff1" }}
        >
          <b>Dispatched Thumbnail</b>
        </StyledTableCell>
        <StyledTableCell
          component="th"
          scope="row"
          align="left"
          style={{ width: "10%", borderColor: "#fff1" }}
        >
          <b>Add To Dispute</b>{" "}
        </StyledTableCell>
        <StyledTableCell
          component="th"
          scope="row"
          align="left"
          style={{ width: "20%", borderColor: "#fff1" }}
        >
          <b>Remarks</b>
        </StyledTableCell>
      </StyledTableRow>
      <StyledTableRow key={"row" + data.id + i}>
        <StyledTableCell
          component="th"
          scope="row"
          align="left"
          style={{ width: "30%", borderColor: "#fff" }}
        >
          <b>{data.productCategoryLabel}</b>
          <br />
          {data.productLabel}
        </StyledTableCell>
        <StyledTableCell
          component="th"
          scope="row"
          align="left"
          style={{ width: "10%", borderColor: "#fff" }}
        >
          {data.productSizeLabel}
        </StyledTableCell>

        <StyledTableCell
          component="th"
          scope="row"
          align="left"
          style={{ width: "10%", borderColor: "#fff" }}
        >
          <div style={{ fontSize: 16, textAlign: "center" }}>
            <img
              alt="img"
              style={{ height: 115, width: 115, marginBottom: 5 }}
              src={`${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/albums/C01ImageView?fileName=${data.productPackagingTypeAsset}`}
            />
          </div>
        </StyledTableCell>
        <StyledTableCell
          component="th"
          scope="row"
          align="left"
          style={{ width: "10%", borderColor: "#fff" }}
        >
          <div
            // onClick={() => this.props.onImageClick(data)}
            style={{ display: "flex", textAlign: "center" }}
          >
            <img
              alt="img"
              style={{
                height: 115,
                width:
                  data.productCategoryLabel == "Theme Mug" ||
                    data.productCategoryLabel == "Themed Photobook" ||
                    data.productCategoryLabel == "Custom Photobook"
                    ? 180
                    : 120,
                marginBottom: 5,
              }}
              src={`${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/albums/C01ImageView?fileName=${data.firstImageFileName}`}
            />
          </div>
        </StyledTableCell>
        <StyledTableCell
          component="th"
          scope="row"
          align="left"
          style={{ width: "10%", borderColor: "#fff" }}
        >
          <div
            // onClick={() => this.props.onImageClick(data)}
            style={{ display: "flex", textAlign: "center" }}
          >
            <img
              alt="img"
              style={{ height: 115, width: 180, marginBottom: 5 }}
              src={`${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/albums/C01ImageView?fileName=${data.dispatchedImage}`}
            />
          </div>
        </StyledTableCell>
        <StyledTableCell
          component="th"
          scope="row"
          align="center"
          style={{ width: "10%", borderColor: "#fff" }}
        >
          <FormControlLabel
            control={
              <Checkbox
                //checked={dt.id}
                onChange={(e) => handleCheckBoxChange(e.target)}
                value={featureId}
                defaultChecked={!isChecked}
                id={"checkBox_" + featureId}
                // name={"checkBox_"+data.typeLabel}
                name={"jobId"}
                color="primary"
                style={{ height: 20 }}
              />
            }
          //label="Add To Dispute"
          />
        </StyledTableCell>
        <StyledTableCell
          component="th"
          scope="row"
          align="center"
          style={{ width: "20%", borderColor: "#fff" }}
        >
          {isDisabled && (
            <TextField
              id="voucher-usage-limit"
              variant="outlined"
              required={isDisabled}
              name={"jobRemarks"}
              fullWidth
            />
          )}
        </StyledTableCell>
      </StyledTableRow>
    </>
  );
}

DisputedDetail.propTypes = {
  data: PropTypes.object,
};

DisputedDetail.defaultProps = {
  data: {},
};

function DisputedJobs(props) {
  // eslint-disable-next-line react/prop-types
  const { classes, data = {} } = props;
  const { DetailList = [] } = data;

  const detail = !IsEmpty(DetailList) ? DetailList[0].items : [];

  // eslint-disable-next-line no-unused-vars
  const [remarks, setRemarks] = useState("");
  const [returnTypeId, setReturnTypeId] = useState("");

  const onChangeRemarks = (e) => {
    setRemarks(e.target.value);
  };

  return (
    <Fragment>
      <Grid item xs={12}>
        <div style={{ width: "100%" }}>
          <TableContainer component={Paper}>
            <Table
              className={classes.table}
              size="small"
              aria-label="customized table"
            >
              <TableBody>
                {!IsEmpty(detail) ? (
                  detail.map((dt, i) => (
                    <DisputedDetail
                      key={"featureData" + dt.id}
                      classes={classes}
                      data={dt}
                      featureId={dt.id}
                      featureLabel={dt.productLabel}
                      isChecked={true}
                      i={i}
                    />
                  ))
                ) : (
                  <StyledTableRow>
                    <StyledTableCell component="th" scope="row" colSpan={4}>
                      <center>
                        <b>No Data</b>
                      </center>
                    </StyledTableCell>
                  </StyledTableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
          <br />
          {!IsEmpty(detail) && (
            <>
              <TextField
                id="voucher-usage-limit"
                label="Reason"
                variant="outlined"
                fullWidth
                name={"returnTypeId"}
                select
                value={returnTypeId}
                onChange={(e) => setReturnTypeId(e.target.value)}
                style={{
                  marginBottom: 15,
                }}
              >
                {data.disputeReturnTypes.map((item) => {
                  return (
                    <MenuItem
                      disabled={item.isDisabled == 1}
                      key={item.id}
                      value={item.id}
                    >
                      {item.label}
                    </MenuItem>
                  );
                })}
              </TextField>
              <TextField
                id="voucher-usage-limit"
                label="General Remarks"
                variant="outlined"
                fullWidth
                name={"orderRemarks"}
                onChange={(event) => onChangeRemarks(event)}
                size={20}
                multiline
                rows={3}
              />
            </>
          )}
        </div>
      </Grid>
    </Fragment>
  );
}

DisputedJobs.propTypes = {
  classes: PropTypes.object,
};

DisputedJobs.defaultProps = {
  classes: {},
};

class F302SaleOrderDisputeForm extends React.Component {
  constructor(props) {
    super(props);
    const ckAdminObject = localStorage.getItem("ckAdminUser") || "{}";
    const ckAdminJsonObject = JSON.parse(ckAdminObject) || {};
    const storedToken = ckAdminJsonObject.jwttoken || "";
    const current = new Date();
    let currentMonth = "";
    let currentDate = "";
    if (current.getMonth() + 1 < 10) {
      currentMonth = `0${current.getMonth() + 1}`;
    } else {
      currentMonth = `${current.getMonth() + 1}`;
    }
    if (current.getDate() < 10) {
      currentDate = `0${current.getDate()}`;
    } else {
      currentDate = `${current.getDate()}`;
    }
    const currentDateTime = `${current.getFullYear()}-${currentMonth}-${currentDate}`;
    console.log("current data", currentDateTime);

    this.state = {
      recordId: this.props.match.params.recordId,
      voucherCode: "",
      voucherLabel: "",
      voucherDescription: "",
      //Voucher Amount Type
      //1-> Percentage
      //2-> Amount
      voucherAmountType: "1",
      voucherPercentage: "",
      voucherAmount: "",
      voucherCategoriesList: [],
      selectedVoucherCategoriesList: [],
      selectAllCategoryProducts: false,
      voucherCategoryProductList: [],
      selectedVoucherCategoriesProductList: [],
      isVoucherAvailableForAllUsers: "1",
      minimumVoucherApplicableAmount: "",
      voucherUsageLimit: "",
      orderId: "",
      selectedOrderObj: {},
      effectiveVoucherFrom: "",
      effectiveVoucherTo: "",
      isVoucherReadyToSubmit: false,
      isOpenSnackbar: false,
      snackbarMessage: "",
      snackbarSeverity: "",
      token: storedToken,
      colourOptions: [
        { value: "ocean", label: "Ocean", color: "#00B8D9", isFixed: true },
        { value: "blue", label: "Blue", color: "#0052CC", isDisabled: true },
        { value: "purple", label: "Purple", color: "#5243AA" },
        { value: "red", label: "Red", color: "#FF5630", isFixed: true },
        { value: "orange", label: "Orange", color: "#FF8B00" },
        { value: "yellow", label: "Yellow", color: "#FFC400" },
        { value: "green", label: "Green", color: "#36B37E" },
        { value: "forest", label: "Forest", color: "#00875A" },
        { value: "slate", label: "Slate", color: "#253858" },
        { value: "silver", label: "Silver", color: "#666666" },
        { value: "ocean1", label: "Ocean1", color: "#00B8D9", isFixed: true },
        { value: "blue1", label: "Blue1", color: "#0052CC", isDisabled: true },
        { value: "purple1", label: "Purple1", color: "#5243AA" },
        { value: "red1", label: "Red1", color: "#FF5630", isFixed: true },
        { value: "orange1", label: "Orange1", color: "#FF8B00" },
        { value: "yellow1", label: "Yellow1", color: "#FFC400" },
        { value: "green1", label: "Green1", color: "#36B37E" },
        { value: "forest1", label: "Forest1", color: "#00875A" },
        { value: "slate1", label: "Slate1", color: "#253858" },
        { value: "silver1", label: "Silver1", color: "#666666" },
      ],
      ordersList: [],
      selectedUsersList: [],
      selectStoreWideCategories: false,
      DetailList: [],
      isLoading: false,
      deliveryDate: "",
      bookingDate: "",
      dispatchDate: "",
      statusLabel: "",
      deliveryStatusLabel: "",
      consignmentNo: "",
      deliveryPartnerLabel: "",
      isOpenImageViewer: false,
      isOlderThan10Days: 0,

      disputeReturnTypes: [],
      disputeReturnTypesLoading: false,
      disputeReturnTypeId: "",
      disputeReturnTypeIdError: "",

      isLoginMenu: false,
      isReload: true,
    };
  }

  componentDidMount() {
    this.getOrdersData();
    const id = this.props.match.params.recordId;

    if (id != 0) {
      let jsonNode = {
        value: id,
        label: id,
        id: id,
        userLabel: id,
        isFixed: false,
        isDisabled: false,
      };


      let orderList = this.state.ordersList;



      // this.setState({
      //   recordId: id,
      //   selectedOrderObj: jsonNode
      // });

      if (orderList.find(x => JSON.stringify(x) === JSON.stringify(jsonNode))) {
        this.setOrder(jsonNode);
      }

      //this.getData();
    }
  }

  handleSnackbar = (isOpen, message, severity) => {
    ////debugger;
    this.setState({
      isOpenSnackbar: isOpen,
      snackbarMessage: message,
      snackbarSeverity: severity,
    });
  };

  setVoucherAmountType = async (e) => {
    await this.setState({
      voucherAmountType: e.target.value,
    });
    this.validateVoucherForm();
  };

  setVoucherCategoryV2 = async (e) => {
    console.log(e);
    this.state.selectedVoucherCategoriesList = [];
    await this.setState({
      selectedVoucherCategoriesList: e,
    });
    this.getVoucherCategoriesProductData(e);
  };

  setOrder = async (e) => {
    console.log(" setOrder YOO ==>> ", { e })

    this.setState({
      orderId: e.id,
      selectedOrderObj: e || {},
    });

    this.getOrderDetailData(e.id);
    this.getDisputeReturnTypesData(e.id);
  };

  getOrderDetailData = async (orderId) => {
    const data = new FormData();
    const myId = orderId || this.state.orderId;
    data.append("orderId", myId);
    const res = await HttpRequest(
      "POST",
      `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/sales/C302SaleOrderItemsView`,
      data,
      "authorize"
    );
    if (res.isSuccess) {
      console.log("voucher categories response", res);
      if (res.data != null && res.data.length > 0) {
        this.setState({
          DetailList: res.data,
          consignmentNo: res.data[0].consignmentNo,
          bookingDate: res.data[0].bookingDate,
          deliveryDate: res.data[0].deliveryDate,
          dispatchDate: res.data[0].dispatchDate,
          statusLabel: res.data[0].statusLabel,
          deliveryStatusLabel: res.data[0].deliveryStatusLabel,
          deliveryPartnerLabel: res.data[0].deliveryPartnerLabel,
          isOlderThan10Days: res.data[0].isOlderThan10Days,
        });
      }
    }
  };

  getVoucherCategoriesProductData = async (selectedVoucherCategoriesList) => {
    let voucherCategoryProductDataList = [];
    if (selectedVoucherCategoriesList.length > 0) {
      const data = new FormData();
      for (let i = 0; i < selectedVoucherCategoriesList.length; i++) {
        data.append("categoryId", selectedVoucherCategoriesList[i].id);
      }
      const res = await HttpRequest(
        "POST",
        `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/common/C300CommonProductsView`,
        data,
        "authorize"
      );
      if (res.isSuccess) {
        console.log("voucher products response", res);
        if (res.data != null && res.data.length > 0) {
          for (let i = 0; i < res.data.length; i++) {
            let jsonNode = {
              value: res.data[i].label,
              label: res.data[i].label,
              id: res.data[i].id,
              userLabel: res.data[i].userLabel,
              isFixed: false,
              isDisabled: false,
            };
            voucherCategoryProductDataList.push(jsonNode);
          }
          this.setState({
            voucherCategoryProductList: voucherCategoryProductDataList,
          });
        }
      }
    }
  };

  getGeneratedVoucherCodeFromServer = async () => {
    const res = await HttpRequest(
      "GET",
      `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/common/C300CommonProductsDiscountVouchersGenerateView`,
      null,
      "authorizeJson"
    );
    if (res.isSuccess) {
      if (res.data != null && res.data.length > 0) {
        const vCode = res.data[0]["voucherCode"];
        console.log(vCode);
        await this.setState({
          voucherCode: vCode,
        });
        this.validateVoucherForm();
      }
    }
  };

  getDisputeReturnTypesData = async (orderId) => {
    const myOrderId = orderId || this.state.orderId;

    const res = await HttpRequest(
      "GET",
      `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/sales/C302SaleDisputeOrdersReturnTypes?orderId=${myOrderId}`,
      null,
      "authorizeJson"
    );
    if (res.isSuccess) {
      const myData = res.data || [];
      this.setState({
        disputeReturnTypes: myData,
      });
    }
  };

  getOrdersData = async () => {
    let ordersList = [];
    const res = await HttpRequest(
      "GET",
      `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/sales/C302SaleOrdersView`,
      null,
      "authorizeJson"
    );
    if (res.isSuccess) {
      console.log("user  response", res);
      if (res.data != null && res.data.length > 0) {
        for (let i = 0; i < res.data.length; i++) {
          let jsonNode = {
            value: res.data[i].id,
            label: res.data[i].id,
            id: res.data[i].id,
            userLabel: res.data[i].id,
            isFixed: false,
            isDisabled: false,
          };
          ordersList.push(jsonNode);
        }
        this.setState({
          ordersList: ordersList,
        });
      }

      console.log("user  ordersList", ordersList);
    } else {
      if (res.statusCode === 401) {
        this.setState({
          isLoginMenu: true,
        });
      } else {
        this.handleSnackbar(true, res.message, "error");
      }
    }
  };

  saveOnlyRemarks = async () => {
    let myForm = document.getElementById("myForm");
    const data = new FormData(myForm);

    const res = await HttpRequest(
      "POST",
      `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/sales/C302SaleDisputedOrdersRemarksSave`,
      data,
      "authorize"
    );

    if (res.isSuccess) {
      this.handleSnackbar(true, "Saved", "success");
      this.setState({
        recordId: 0,
      });
      window.location.reload();
    } else {
      if (res.statusCode === 401) {
        this.setState({
          isLoginMenu: true,
          isReload: false,
        });
      } else {
        this.handleSnackbar(true, res.message, "error");
      }
    }
  };

  generateTicket = async () => {
    let myForm = document.getElementById("myForm");
    const data = new FormData(myForm);

    const res = await HttpRequest(
      "POST",
      `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/sales/C302SaleDisputedOrdersSave`,
      data,
      "authorize"
    );

    if (res.isSuccess) {
      this.handleSnackbar(true, "Saved", "success");
      this.setState({
        recordId: 0,
      });
      window.location.reload();
    } else {
      if (res.statusCode === 401) {
        this.setState({
          isLoginMenu: true,
          isReload: false,
        });
      } else {
        this.handleSnackbar(true, res.message, "error");
      }
    }
  };

  viewReport = async () => {
    window.location = "#/F300DiscountVoucherReport";
  };

  setVoucherCategoryProductV2 = async (e) => {
    this.state.selectedVoucherCategoriesProductList = [];
    await this.setState({
      selectedVoucherCategoriesProductList: e,
    });
    this.validateVoucherForm();
  };

  updateAllCategoryProductsSelection = async (e) => {
    await this.setState({
      selectAllCategoryProducts: e.target.checked,
    });
    this.validateVoucherForm();
  };

  updateStoreWideCategoriesSelection = async (e) => {
    await this.setState({
      selectStoreWideCategories: e.target.checked,
    });
  };

  setVoucherAvailableForAll = async (e) => {
    await this.setState({
      isVoucherAvailableForAllUsers: e.target.value,
    });
    this.validateVoucherForm();
  };

  setEffectiveFrom = async (e) => {
    let date = e.target.value;
    const arr = date.split("-");
    const formattedDate = `${arr[2]}-${arr[1]}-${arr[0]}`;
    await this.setState({
      effectiveVoucherFrom: formattedDate,
    });
    this.validateVoucherForm();
  };

  setEffectiveTo = async (e) => {
    let date = e.target.value;
    const arr = date.split("-");
    const formattedDate = `${arr[2]}-${arr[1]}-${arr[0]}`;
    await this.setState({
      effectiveVoucherTo: formattedDate,
    });
    this.validateVoucherForm();
  };

  validateVoucherForm() {
    let isAllFieldsValidated;
    if (this.state.isVoucherAvailableForAllUsers === "1") {
      isAllFieldsValidated = true;
    } else {
      if (this.state.orderId) {
        isAllFieldsValidated = true;
      } else {
        isAllFieldsValidated = false;
        this.setState({
          isVoucherReadyToSubmit: isAllFieldsValidated,
        });
        return isAllFieldsValidated;
      }
    }

    if (this.state.voucherLabel) {
      isAllFieldsValidated = true;
    } else {
      isAllFieldsValidated = false;
      this.setState({
        isVoucherReadyToSubmit: isAllFieldsValidated,
      });
      return isAllFieldsValidated;
    }

    if (this.state.voucherDescription) {
      isAllFieldsValidated = true;
    } else {
      isAllFieldsValidated = false;
      this.setState({
        isVoucherReadyToSubmit: isAllFieldsValidated,
      });
      return isAllFieldsValidated;
    }

    if (this.state.voucherCode) {
      isAllFieldsValidated = true;
    } else {
      isAllFieldsValidated = false;
      this.setState({
        isVoucherReadyToSubmit: isAllFieldsValidated,
      });
      return isAllFieldsValidated;
    }
    if (this.state.voucherAmountType === "1") {
      if (this.state.voucherPercentage) {
        isAllFieldsValidated = true;
      } else {
        isAllFieldsValidated = false;
        this.setState({
          isVoucherReadyToSubmit: isAllFieldsValidated,
        });
        return isAllFieldsValidated;
      }
    } else {
      if (this.state.voucherAmount) {
        isAllFieldsValidated = true;
      } else {
        isAllFieldsValidated = false;
        this.setState({
          isVoucherReadyToSubmit: isAllFieldsValidated,
        });
        return isAllFieldsValidated;
      }
    }

    if (this.state.selectedVoucherCategoriesList.length > 0) {
      isAllFieldsValidated = true;
      if (
        this.state.selectedVoucherCategoriesProductList.length > 0 ||
        this.state.selectAllCategoryProducts
      ) {
        isAllFieldsValidated = true;
      } else {
        isAllFieldsValidated = false;
        this.setState({
          isVoucherReadyToSubmit: isAllFieldsValidated,
        });
        return isAllFieldsValidated;
      }
    } else {
      isAllFieldsValidated = false;
      this.setState({
        isVoucherReadyToSubmit: isAllFieldsValidated,
      });
      return isAllFieldsValidated;
    }

    if (this.state.minimumVoucherApplicableAmount) {
      isAllFieldsValidated = true;
    } else {
      isAllFieldsValidated = false;
      this.setState({
        isVoucherReadyToSubmit: isAllFieldsValidated,
      });
      return isAllFieldsValidated;
    }

    if (this.state.voucherUsageLimit) {
      isAllFieldsValidated = true;
    } else {
      isAllFieldsValidated = false;
      this.setState({
        isVoucherReadyToSubmit: isAllFieldsValidated,
      });
      return isAllFieldsValidated;
    }

    if (this.state.effectiveVoucherFrom) {
      isAllFieldsValidated = true;
    } else {
      isAllFieldsValidated = false;
      this.setState({
        isVoucherReadyToSubmit: isAllFieldsValidated,
      });
      return isAllFieldsValidated;
    }

    if (this.state.effectiveVoucherTo) {
      isAllFieldsValidated = true;
    } else {
      isAllFieldsValidated = false;
      this.setState({
        isVoucherReadyToSubmit: isAllFieldsValidated,
      });
      return isAllFieldsValidated;
    }
    if (isAllFieldsValidated) {
      this.setState({
        isVoucherReadyToSubmit: isAllFieldsValidated,
      });
    }
  }

  render() {
    const { classes } = this.props;

    return (
      <Fragment>
        <LoginMenu
          reload={this.state.isReload}
          open={this.state.isLoginMenu}
          handleClose={() => this.setState({ isLoginMenu: false })}
        />
        <Grid
          container
          xs={12}
          direction={"column"}
          justifyContent="center"
          alignItems="center"
          style={{ padding: 10 }}
        >
          <Toolbar>
            <NavBar isAuthorize title="Sale Order Dispute Form" />
          </Toolbar>
          <ImageViewDialogV2
            downloadFile={(e, fileName) => this.downloadFile(e, fileName)}
            handleClose={() => this.handleCloseImageDialog()}
            open={this.state.isOpenImageViewer}
            data={this.state}
            onNextArrowClick={() => this.onNextArrowClick()}
            onBackArrowClick={() => this.onBackArrowClick()}
          />
          <Card
            style={{
              width: "94%",
              marginRight: "3%",
              marginLeft: "3%",
              overflow: "auto",
            }}
          >
            <form id="myForm" style={{ padding: "1%", height: "100vh" }}>
              <Grid
                item
                xs={12}
                alignItems="center"
                justifyContent="center"
                direction={"column"}
              >
                <Grid
                  container
                  style={{
                    position: "relative",
                    zIndex: 10,
                    // alignContent:"center"
                  }}
                  alignItems="center"
                  justifyContent="space-between"
                >
                  <Grid
                    item
                    xs={3}
                    style={{ paddingBottom: 20, alignItems: "center" }}
                  >
                    <Typography
                      variant="subtitle2"
                      align="left"
                      color="textSecondary"
                      style={{ paddingBottom: 5 }}
                    >
                      Select Order
                    </Typography>
                    <Select
                      name="orderId"
                      options={this.state.ordersList}
                      onChange={(e) => {

                        this.setOrder(e);
                      }}
                      className="basic-multi-select"
                      classNamePrefix="select"
                      clearIndicator={false}
                      value={this.state.selectedOrderObj}
                    />
                  </Grid>

                  <Grid
                    item
                    xs={5}
                    style={{ paddingBottom: 20, alignItems: "center" }}
                  >
                    <Grid spacing={2} container>
                      <Grid item xs={4}>
                        <Typography
                          variant="subtitle2"
                          align="left"
                          color="textSecondary"
                          style={{ paddingBottom: 5 }}
                        >
                          Booking Date
                        </Typography>
                        <TextField
                          id="voucher-usage-limit"
                          variant="outlined"
                          fullWidth
                          value={this.state.bookingDate}
                          size="small"
                        //multiline={4}
                        />
                      </Grid>
                      <Grid item xs={4}>
                        <Typography
                          variant="subtitle2"
                          align="left"
                          color="textSecondary"
                          style={{ paddingBottom: 5 }}
                        >
                          Dispatch Date
                        </Typography>
                        <TextField
                          id="voucher-usage-limit"
                          variant="outlined"
                          fullWidth
                          value={this.state.dispatchDate}
                          size="small"
                        //multiline={4}
                        />
                      </Grid>
                      <Grid item xs={4}>
                        <Typography
                          variant="subtitle2"
                          align="left"
                          color="textSecondary"
                          style={{ paddingBottom: 5 }}
                        >
                          Delivery Date
                        </Typography>
                        <TextField
                          id="voucher-usage-limit"
                          variant="outlined"
                          fullWidth
                          value={this.state.deliveryDate}
                          size="small"
                        //multiline={4}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>

              {this.state.orderId && (
                <>
                  <Grid item xs={12}>
                    <div
                      style={{
                        display: "flex",
                        marginBottom: 20,
                        marginTop: 10,
                      }}
                    >
                      <b>Order No: </b>{" "}
                      <div
                        style={{
                          fontSize: 17,
                          marginLeft: 10,
                          marginRight: 10,
                        }}
                      >
                        CK-{this.state.orderId}
                      </div>
                      <b>Delivery Partner: </b>{" "}
                      <div
                        style={{
                          fontSize: 17,
                          marginLeft: 10,
                          marginRight: 10,
                        }}
                      >
                        {this.state.deliveryPartnerLabel}
                      </div>
                      <b>Delivery CN:</b>{" "}
                      <div
                        style={{
                          fontSize: 17,
                          marginLeft: 10,
                          marginRight: 10,
                        }}
                      >
                        {this.state.consignmentNo}
                      </div>
                      <b>Status:</b>{" "}
                      <div
                        style={{
                          fontSize: 17,
                          marginLeft: 10,
                          marginRight: 10,
                        }}
                      >
                        {this.state.statusLabel}
                      </div>
                    </div>
                  </Grid>
                  <Grid item xs={12}>
                    <div
                      style={{
                        display: "flex",
                        marginBottom: 20,
                      }}
                    >
                      <b>Delivery Status:</b>{" "}
                      <div
                        style={{
                          fontSize: 17,
                          marginLeft: 10,
                          marginRight: 10,
                        }}
                      >
                        {this.state.deliveryStatusLabel}
                      </div>
                    </div>
                  </Grid>
                </>
              )}
              <Grid container xs={12}>
                <DisputedJobs
                  key={"featureData"}
                  classes={classes}
                  data={this.state}
                  isOpen={false}
                  deliveryDate={this.state.deliveryDate}
                />
              </Grid>
              <br />
              <br />
              <Grid
                xs={12}
                container
                alignContent="center"
                justifyContent="center"
              >
                <Button
                  disabled={this.state.sel}
                  variant="contained"
                  color="primary"
                  onClick={() => {
                    this.state.isOlderThan10Days == 0
                      ? this.generateTicket()
                      : this.saveOnlyRemarks();
                  }}
                >
                  {this.state.isOlderThan10Days == 0
                    ? "Generate Ticket"
                    : "Save Remarks"}
                </Button>
              </Grid>
            </form>
          </Card>
          <CustomizedSnackbar
            isOpen={this.state.isOpenSnackbar}
            message={this.state.snackbarMessage}
            severity={this.state.snackbarSeverity}
            handleCloseSnackbar={() => this.handleSnackbar(false, "", "")}
            autoHideDuration={3000}
          />
        </Grid>
      </Fragment>
    );
  }
}

F302SaleOrderDisputeForm.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(useStyles)(F302SaleOrderDisputeForm);
